import { render, staticRenderFns } from "./EthnicitiesPage.vue?vue&type=template&id=f579fecc&"
import script from "./EthnicitiesPage.vue?vue&type=script&lang=js&"
export * from "./EthnicitiesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports